import { useState, useEffect } from "react";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useModal } from "../../contexts/ModalContext";

const menuList = [
    {
        label: "Home",
        link: "/",
        submenus: [],
    },
    {
        label: "ESG Tech",
        link: "/",
        submenus: [
            {
                submenuLabel: "Vajra",
                submenuLink: "/vajra",
            },
            {
                submenuLabel: "myKarb",
                submenuLink: "/myKarb",
            },
            {
                submenuLabel: "cbamSuite",
                submenuLink: "/cbam",
            },
        ],
    },
    {
        label: "Training",
        link: "/esg-trainings",
        submenus: [],
    },
    {
        label: "Solutions",
        link: "/solutions",
        submenus: [],
    },
    {
        label: "About",
        link: "/about-us",
        submenus: [
            /* {
                submenuLabel: "Learning and Resources",
                submenuLink: "/about/learning-and-resources",
            },
            {
                submenuLabel: "Careers",
                submenuLink: "/career",
            },
            {
                submenuLabel: "Membership and Partnership",
                submenuLink: "/membership-and-partnership",
            },
            {
                submenuLabel: "Portfolio",
                submenuLink: "/portfolio",
            },
            {
                submenuLabel: "Event and Gallery",
                submenuLink: "/event-and-gallery",
            } */
        ],
    },
    {
        label: "Resources",
        link: "/resources",
        submenus: [
            {
                submenuLabel: "Blogs",
                submenuLink: "/blogs",
            },
            {
                submenuLabel: "Whitepapers",
                submenuLink: "/whitepaper",
            },
            // {
            //     submenuLabel: "Case Studies",
            //     submenuLink: "/case-studies",
            // },
            {
                submenuLabel: "Standards & Frameworks",
                submenuLink: "/resources",
            },
        ],
    },
    {
        label: "Contact",
        link: "/contact-us",
        submenus: [],
    },
];

export default function NewHeader() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { openModal } = useModal();

    // Close mobile menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
        setOpenDropdown(null);
    }, [location.pathname]);

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    return (
        <header
            className="flex justify-center w-full py-4 bg-transparent fixed top-0 z-[9999]"
        >
            <div className="w-[90%] sm:py-0 py-3 max-w-7xl bg-[#EDEDED]/80 backdrop-blur-md rounded-full px-6 flex items-center justify-between shadow-md">
                {/* Logo */}
                <div className="flex items-center gap-3 cursor-pointer" onClick={() => {
                    navigate("/");
                    setIsMobileMenuOpen(false);
                }}>
                    <img src="/nirantara-logo-new2.png" alt="Nirantara Logo" className="w-auto" />
                </div>

                {/* Desktop Menu */}
                <nav className="relative items-center hidden gap-8 font-medium text-black md:flex">
                    {menuList.map((menu, index) => (
                        <div
                            key={index}
                            className="relative flex items-center"
                            onMouseEnter={() => setOpenDropdown(index)}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <NavLink
                                to={menu.link}
                                className={`py-6 flex items-center hover:text-[#FF7A00] ${menu.active ? 'text-[#FF7A00]' : ''}`}
                            >
                                {menu.label}
                                {menu.submenus.length > 0 && (
                                    <FaChevronDown className="ml-1 text-xs" />
                                )}
                            </NavLink>

                            {menu.submenus.length > 0 && openDropdown === index && (
                                <div className="absolute left-0 top-full bg-white shadow-lg z-50 min-w-[180px]">
                                    {menu.submenus.map((submenu, subIndex) => (
                                        <NavLink
                                            key={subIndex}
                                            to={submenu.submenuLink}
                                            className="block text-nowrap px-4 py-3 text-sm text-black hover:bg-gray-100 hover:text-[#FF7A00]"
                                            onClick={() => { setOpenDropdown(null); }}
                                        >
                                            {submenu.submenuLabel}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </nav>


                <button
                    onClick={openModal}
                    className="hidden md:block bg-[#F28C1D] text-white px-6 py-2 rounded-full font-medium hover:bg-[#e67e00] transition">
                    Book a Demo
                </button>

                <button
                    className="text-black md:hidden"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="absolute top-20 w-[90%] max-w-7xl bg-[#EDEDED] rounded-2xl shadow-lg p-6 flex flex-col gap-2 md:hidden text-black font-medium">
                    {menuList.map((menu, index) => (
                        <div key={index}>
                            <button
                                onClick={() => {
                                    if (menu.submenus.length > 0) {
                                        toggleDropdown(index);
                                        navigate(menu.link);
                                    } else {
                                        navigate(menu.link);
                                        setIsMobileMenuOpen(false);
                                    }
                                }}
                                className="flex justify-between items-center w-full py-2 hover:text-[#FF7A00]"
                            >
                                {menu.label}
                                {menu.submenus.length > 0 && <FaChevronDown size={12} />}
                            </button>

                            {/* Mobile Submenus */}
                            {openDropdown === index && menu.submenus.length > 0 && (
                                <div className="flex flex-col gap-2 pl-4 mt-1">
                                    {menu.submenus.map((submenu, subIndex) => (
                                        <NavLink
                                            key={subIndex}
                                            to={submenu.submenuLink}
                                            className="block text-sm py-2 text-black hover:text-[#FF7A00]"
                                            onClick={() => setIsMobileMenuOpen(false)}
                                        >
                                            {submenu.submenuLabel}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}

                    {/* Mobile CTA */}
                    <button className="mt-4 bg-[#F28C1D] text-white px-6 py-2 rounded-full font-medium hover:bg-[#e67e00] transition">
                        Book a Demo
                    </button>
                </div>
            )}
        </header>
    );
}
